import _defineProperty from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins_home/workspace/tingle.f3dda73f-99f7-4e8b-be38-8576aab5738d/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled from 'styled-components';
import { spacer4, spacer8, spacer16, spacer20, spacer24, spacer40, screenSmMax, cssColorValue, ButtonTertiary, Type } from '@spotify-internal/encore-web';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { useSwipeable } from 'react-swipeable';
import { Crossfade, DELAYS, fadeInAnimation, HeadlineWithSupertextComponent, ImageAspectBox21x9, withAnimationContext } from '../../ui';
import { Testimonial } from '../SingleTestimonialModule/Testimonial';
import { ContentfulImage } from '../../Contentful/ContentfulImage';
import { getTallest, setTallestClass, withoutProps } from '../../utils';
import { useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var GroupTestimonial = styled.div.withConfig({
  displayName: "GroupTestimonialModule__GroupTestimonial",
  componentId: "br8p69-0"
})(["display:flex;flex-direction:column;height:100%;"]);
var Bottom = styled.div.withConfig({
  displayName: "GroupTestimonialModule__Bottom",
  componentId: "br8p69-1"
})(["display:flex;flex-direction:row;padding:", " 0px 0px 0px;justify-content:space-between;@media (max-width:", "){flex-direction:column;padding:", " 0px;}"], spacer40, screenSmMax, spacer20);
var Left = styled.div.withConfig({
  displayName: "GroupTestimonialModule__Left",
  componentId: "br8p69-2"
})(["width:35%;text-align:left;@media (max-width:", "){width:100%;}"], screenSmMax);
var NameList = styled.div.withConfig({
  displayName: "GroupTestimonialModule__NameList",
  componentId: "br8p69-3"
})(["display:flex;flex-direction:column;@media (max-width:", "){flex-direction:column;padding:", " 0px;display:none;}"], screenSmMax, spacer20);
var CurrentSource = withAnimationContext(styled(Type.p).attrs({
  variant: Type.heading1,
  weight: Type.bold
}).withConfig({
  displayName: "GroupTestimonialModule__CurrentSource",
  componentId: "br8p69-4"
})(["", ";padding-bottom:", ";@media (min-width:", "){padding-top:", ";}"], fadeInAnimation(DELAYS.SECOND), spacer24, screenSmMax, spacer16));
var Right = styled.div.withConfig({
  displayName: "GroupTestimonialModule__Right",
  componentId: "br8p69-5"
})(["width:60%;padding-left:", ";@media (max-width:", "){width:100%;align-items:center;padding-left:0;padding-top:", ";}"], spacer16, screenSmMax, spacer16);
var Name = withAnimationContext(styled(withoutProps(ButtonTertiary, 'animationContext')).withConfig({
  displayName: "GroupTestimonialModule__Name",
  componentId: "br8p69-6"
})(["", ";text-align:left;padding:", " 0;&::after,&:focus::after{border-bottom:0;}&:focus,&:hover:not(:focus):not(:disabled){color:", ";}&.active{display:none;}"], fadeInAnimation(DELAYS.THIRD), spacer8, function (_ref) {
  var theme = _ref.theme;
  return hexToRgba(theme.box.text, 0.25);
}));
export var Dots = styled.div.withConfig({
  displayName: "GroupTestimonialModule__Dots",
  componentId: "br8p69-7"
})(["display:none;justify-content:center;flex-direction:row;@media (max-width:", "){display:flex;justify-content:center;padding:0px;}"], screenSmMax);
var ImageContainer = styled(ImageAspectBox21x9).withConfig({
  displayName: "GroupTestimonialModule__ImageContainer",
  componentId: "br8p69-8"
})([""]);
var TestimonialContainer = styled.div.withConfig({
  displayName: "GroupTestimonialModule__TestimonialContainer",
  componentId: "br8p69-9"
})(["position:relative;overflow:hidden;height:", "px;"], function (_ref2) {
  var tallest = _ref2.tallest;
  return tallest > 0 ? tallest : 250;
});
var CrossfadeImage = styled.div.withConfig({
  displayName: "GroupTestimonialModule__CrossfadeImage",
  componentId: "br8p69-10"
})(["overflow:hidden;position:absolute;height:100%;width:100%;", ""], Crossfade);
var CrossfadeText = styled.div.withConfig({
  displayName: "GroupTestimonialModule__CrossfadeText",
  componentId: "br8p69-11"
})(["position:absolute;", ""], Crossfade);
export var Dot = styled.div.withConfig({
  displayName: "GroupTestimonialModule__Dot",
  componentId: "br8p69-12"
})(["display:none;border-radius:50%;width:", ";height:", ";margin-left:", ";margin-right:", ";background:", ";&.active{background:", ";}@media (max-width:", "){display:flex;}&:hover{cursor:pointer;}"], spacer8, spacer8, spacer4, spacer4, cssColorValue('backgroundPress'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.box.text;
}, screenSmMax);
var testimonialRefs = [];

var getTestimonials = function getTestimonials(activeIndex, testimonials) {
  return testimonials.map(function (testimonial, index) {
    testimonialRefs[index] = React.useRef();
    return /*#__PURE__*/_jsx(CrossfadeText, {
      ref: testimonialRefs[index],
      active: activeIndex === index,
      children: /*#__PURE__*/_jsx(Testimonial, {
        quote: testimonial.quote,
        source: testimonial.source,
        jobTitle: testimonial.jobTitle
      })
    }, "testimonial-text-".concat(index));
  });
};

var getCurrentSource = function getCurrentSource(list, index) {
  var _list$index;

  return (_list$index = list[index]) === null || _list$index === void 0 ? void 0 : _list$index.source;
};

export var GroupTestimonialModule = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var _ref4$testimonials = _ref4.testimonials,
      testimonials = _ref4$testimonials === void 0 ? [] : _ref4$testimonials;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeIndex = _React$useState2[0],
      setActiveIndex = _React$useState2[1];

  var t = useT();

  var nextIndex = function nextIndex(i) {
    return i + 1 >= testimonials.length ? 0 : i + 1;
  };

  var prevIndex = function prevIndex(i) {
    return i - 1 >= 0 ? i - 1 : testimonials.length - 1;
  };

  var swipeHandlers = useSwipeable({
    onSwipedLeft: function onSwipedLeft() {
      return jumpToTestimonial(nextIndex(activeIndex));
    },
    onSwipedRight: function onSwipedRight() {
      return jumpToTestimonial(prevIndex(activeIndex));
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: false,
    trackTouch: true
  });

  function jumpToTestimonial(index) {
    setActiveIndex(index);
  } // Begin dynamic height


  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      tallest = _React$useState4[0],
      setTallest = _React$useState4[1];

  var _React$useState5 = React.useState(0),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      width = _React$useState6[0],
      setWidth = _React$useState6[1];

  var items = testimonials.filter(Boolean).filter(function (testimonial) {
    return !testimonial.sys;
  });
  var showImage = items.every(function (testimonial) {
    return testimonial.image;
  });
  React.useEffect(function () {
    setTallest(getTallest(testimonialRefs));
    setTallestClass(testimonialRefs);
  }, [getTallest(testimonialRefs), width]);
  React.useEffect(function () {
    var handleResize = function handleResize() {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return function cleanupListener() {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // end dynamic height

  return /*#__PURE__*/_jsxs(GroupTestimonial, _objectSpread(_objectSpread({}, swipeHandlers), {}, {
    children: [showImage && /*#__PURE__*/_jsx(ImageContainer, {
      children: items.map(function (testimonial, index) {
        return testimonial.image && /*#__PURE__*/_jsx(CrossfadeImage, {
          active: activeIndex === index,
          children: /*#__PURE__*/_jsx(ContentfulImage, {
            asset: testimonial.image,
            caption: testimonial.caption
          })
        }, "testimonial-image-".concat(index));
      })
    }), /*#__PURE__*/_jsxs(Bottom, {
      ref: ref,
      children: [/*#__PURE__*/_jsxs(Left, {
        children: [/*#__PURE__*/_jsx(HeadlineWithSupertextComponent, {
          supertext: t('FRODOR_f614fe', 'featuring', '')
        }), /*#__PURE__*/_jsx(CurrentSource, {
          children: getCurrentSource(items, activeIndex)
        }), /*#__PURE__*/_jsx(NameList, {
          children: items.map(function (testimonial, index) {
            return /*#__PURE__*/_jsx(Name, {
              role: "button",
              onClick: function onClick() {
                return jumpToTestimonial(index);
              },
              className: "".concat(activeIndex === index ? 'active' : 'inactive'),
              children: testimonial.source
            }, "testimonial-".concat(testimonial.source));
          })
        })]
      }), /*#__PURE__*/_jsx(Right, {
        children: /*#__PURE__*/_jsx(TestimonialContainer, {
          tallest: tallest,
          children: getTestimonials(activeIndex, items)
        })
      })]
    }), /*#__PURE__*/_jsx(Dots, {
      children: items.map(function (_, index) {
        return /*#__PURE__*/_jsx(Dot, {
          active: activeIndex === index,
          onClick: function onClick() {
            return jumpToTestimonial(index);
          },
          className: "".concat(activeIndex === index ? 'active' : 'inactive')
        }, "dot-".concat(index));
      })
    })]
  }));
});